import userPreferencesRequest from '../lib/userPreferencesRequest';

/*
  * #TODO Remove api-version headers after deployment of UAPI user preferences
  * Must remove conditions in UAPI before deployment
    - 10-27-22 JT
*/
export const getUserPreferences = (params = {}) => {
  // content pinnedHunt, hiddenContent
  // layers active, favorites, opacity, recent
  // TODO: mode
  // tools terrain
  /* TODO Remove headers after deployment of udapi */
  params.headers = { 'API-Version': 'v2' }
  return userPreferencesRequest('get', 'maps', params);
};

export const setUserPreferences = (params = {}) => {
  // content pinnedHunt, hiddenContent
  // layers active, favorites, opacity, recent
  // TODO: mode
  // TODO: sort
  // tools terrain
  /* TODO Remove headers after deployment of udapi */
  params.headers = { 'API-Version': 'v2' }
  return userPreferencesRequest('post', 'maps', params, false,  params.data)
};
